export const ELECTRONIC_SIGNATURE_CONSENT_LABEL =
  'I agree to use electronic signatures for this agreement. I have reviewed and agree to its terms, and I intend my electronic signature to have the same legal effect as my handwritten signature.'
